import { render, staticRenderFns } from "./categoriesFilter.vue?vue&type=template&id=4c18a215"
import script from "./categoriesFilter.vue?vue&type=script&lang=js"
export * from "./categoriesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports